module.exports = __webpack_public_path__ + "img/step1.b6692fab.png";